import { FilePenLine } from "lucide-react";
import React from "react";
import { useForm } from "react-hook-form";
import TextAreaField from "../../components/form/TextAreaField";
import InputField from "../../components/form/InputField";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import { useDispatch, useSelector } from "react-redux";
import {
  donorProposalEmailRecord,
  donorProposalFollowUpEmailRecord,
} from "../../features/projectsSlice";
import { useNotification } from "../../components/notification/NotificationContainer";
import { closeModal } from "../../features/modalSLice";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const SaveEmailRecord = ({ project_id, donor_id, name, type }) => {
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const loading = useSelector(
    (state) => state.projects.load.donorProposalEmailRecord
  );
  const loading2 = useSelector(
    (state) => state.projects.load.donorProposalFollowUpEmailRecord
  );
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      let res;
      ///For the main Email to donors
      if (type === "main") {
        res = await dispatch(
          donorProposalEmailRecord({ project_id, donor_id, data })
        );

        if (donorProposalEmailRecord.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification(res.payload.message, "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      } else {
        ///For the follow up Emails
        res = await dispatch(
          donorProposalFollowUpEmailRecord({ project_id, donor_id, data })
        );

        if (donorProposalFollowUpEmailRecord.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification(res.payload.message, "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };
  useEffect(() => {
    setValue("type", type);
  });

  return (
    <div className="min-w-[85vw] sm:min-w-[35rem] lg:min-w-[50rem] max-w-4xl w-full text-text-1/80">
      <div className="flex  justify-right items-center gap-2 py-3 border-b border-bkg2 mb-4 text-text-1/80">
        <FilePenLine />
        <h4> Save Record </h4>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <p className="mb-4 flex gap-2">{name}</p>
        <InputField
          register={register}
          label="Subject"
          name="subject"
          errors={errors.subject}
        />
        <InputField
          register={register}
          type="hidden"
          name="type"
          defaultValue={type}
        />

        <ResourseButtons loading={loading || loading2} submitText="Save Mail" />
      </form>
    </div>
  );
};

export default SaveEmailRecord;
